import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

import { provideFirebaseApp, initializeApp, FirebaseOptions } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { provideFunctions, getFunctions } from '@angular/fire/functions';

import { getAuth, provideAuth } from '@angular/fire/auth';
import { connectAuthEmulator } from 'firebase/auth';
import { connectStorageEmulator } from 'firebase/storage';
import { connectFirestoreEmulator } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { connectFunctionsEmulator } from 'firebase/functions';
import { referentkaDevFirebaseConfig } from '../firebase/referentka-dev.config';
import { memowlV2FirebaseConfig } from '../firebase/memowl-version-2.config';
import { referentkaFirebaseConfig } from '../firebase/referentka.config';

export const FIREBASE_CONFIG = new InjectionToken<FirebaseOptions>('firebase-config');
export const ENV_ALIAS = new InjectionToken('env-alias');

const useEmulators = false && location.hostname.includes('.ng');
const useFunEmulator = false && location.hostname.includes('.ng');

@NgModule({
    imports: [],
    providers: [
        provideFirebaseApp((injector) =>
            initializeApp(injector.get<FirebaseOptions>(FIREBASE_CONFIG)),
        ),
        provideFirestore(() => {
            const fs = getFirestore();
            if (useEmulators) connectFirestoreEmulator(fs, 'localhost', 8080);
            return fs;
        }),
        provideStorage(() => {
            const st = getStorage();
            if (useEmulators) connectStorageEmulator(st, 'localhost', 9199);
            return st;
        }),
        provideFunctions(() => {
            const f = getFunctions(getApp(), 'europe-west3');
            if (useEmulators || useFunEmulator) {
                // connectFunctionsEmulator(f, 'localhost', 5001);
                connectFunctionsEmulator(f, 'localhost', 5002);
            }
            return f;
        }),
        provideAuth(() => {
            const auth = getAuth();
            if (useEmulators) connectAuthEmulator(auth, 'http://localhost:9099');
            return auth;
        }),
    ],
    declarations: [],
    exports: [],
})
export class CoordinatorModule {
    public static forRoot(environment: any): ModuleWithProviders<CoordinatorModule> {
        console.log('initializing coordinator for environment: ', environment);

        return {
            ngModule: CoordinatorModule,
            providers: [
                {
                    provide: ENV_ALIAS,
                    useValue: environment?.alias,
                },
                {
                    provide: FIREBASE_CONFIG,
                    useFactory: () => {
                        if (!environment?.firebaseProject) {
                            throw new Error('Environment is not set up correctly');
                        }

                        switch (environment.firebaseProject) {
                            case 'referentka-11e99':
                                return referentkaDevFirebaseConfig;
                            case 'memowl':
                                return referentkaFirebaseConfig;
                            case 'memowl-version-2':
                                return memowlV2FirebaseConfig;
                            default:
                                throw new Error(
                                    'Incorrect firebase project, please check environment settings',
                                );
                        }
                    },
                },
            ],
        };
    }
}
